export class SignOutRequest {
  public krugoId: string = '';
  public accessToken: string = '';

  constructor(krugoId, accessToken: string) {
    this.krugoId = krugoId;
    this.accessToken = accessToken;
  }
}
